// import React, { useState } from "react";
// import Navbar from "../../components/Navbar/Navbar";
// import Footer from "../../components/Footer/Footer";

// import "./BuildVoyahFree.css";

// import BuildFreeExterior from "../../components/BuildFree/BuildFreeExterior";
// import BuildFreeInterior from "../../components/BuildFree/BuildFreeInterior";
// import BuildFreeAdditionalEquipment from "../../components/BuildFree/BuildFreeAditionalEquipment";
// import BuildFreeOrder from "../../components/BuildFree/BuildFreeOrder";

// const BuildVoyahFree = () => {
//   // ==========================
//   // BASE PRICE
//   // ==========================
//   const BASE_PRICE = 599000;

//   // ==========================
//   // STATE FOR SELECTED OPTIONS
//   // ==========================
//   const [selectedExterior, setSelectedExterior] = useState(null);
//   const [selectedInterior, setSelectedInterior] = useState(null);
//   const [selectedEquipment, setSelectedEquipment] = useState([]);

//   // ==========================
//   // PRICING RULES
//   // ==========================
//   const colorPrices = {
//     "Snow White": 0,
//     "Cloud Blue": 14900,
//     "Star Night Black": 14900,
//     "Sky Blue": 14900,
//     "Dark Green": 14900,
//   };

//   const equipmentPrices = {
//     1: 47900,
//     2: 3450,
//     3: 3900,
//     4: 15900,
//     5: 7900,
//   };

//   // ==========================
//   // PRICE CALCULATION
//   // ==========================
//   const calculateTotal = () => {
//     let total = BASE_PRICE;

//     // Exterior color
//     if (selectedExterior) {
//       total += colorPrices[selectedExterior.name] || 0;
//     }

//     // Additional equipment (multiple selectable)
//     selectedEquipment.forEach((id) => {
//       total += equipmentPrices[id] || 0;
//     });

//     return total;
//   };

//   const finalPrice = calculateTotal();

//   // ==========================
//   // EQUIPMENT SELECTION TOGGLE
//   // ==========================
//   const toggleEquipment = (id) => {
//     setSelectedEquipment((prev) =>
//       prev.includes(id)
//         ? prev.filter((x) => x !== id)
//         : [...prev, id]
//     );
//   };

//   return (
//     <div className="bvfnaved">
//       <Navbar />

//       {/* EXTERIOR SELECTOR */}
//       <BuildFreeExterior onSelect={(color) => setSelectedExterior(color)} />

//       {/* INTERIOR SELECTOR */}
//       <BuildFreeInterior onSelect={(interior) => setSelectedInterior(interior)} />

//       {/* ADDITIONAL EQUIPMENT */}
//       <BuildFreeAdditionalEquipment
//         selectedEquipment={selectedEquipment}
//         toggleEquipment={toggleEquipment}
//       />

//       {/* ORDER FORM WITH LIVE PRICE */}
//       <BuildFreeOrder finalPrice={finalPrice} />

//       <Footer />
//     </div>
//   );
// };

// export default BuildVoyahFree;


import React, { useEffect, useState } from "react";
import axios from "axios";

import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";

import "./BuildVoyahFree.css";

import BuildFreeExterior from "../../components/BuildFree/BuildFreeExterior";
import BuildFreeInterior from "../../components/BuildFree/BuildFreeInterior";
import BuildFreeAdditionalEquipment from "../../components/BuildFree/BuildFreeAditionalEquipment";
import BuildFreeOrder from "../../components/BuildFree/BuildFreeOrder";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const BuildVoyahFree = () => {
  // =============================================================
  // ALL HOOKS MUST BE AT THE TOP
  // =============================================================

  // Main config (base price + currency)
  const [config, setConfig] = useState(null);

  // Dynamic price lists
  const [colorPrices, setColorPrices] = useState({});
  const [equipmentPrices, setEquipmentPrices] = useState({});

  // Selected options
  const [selectedExterior, setSelectedExterior] = useState(null);
  const [selectedInterior, setSelectedInterior] = useState(null);
  const [selectedEquipment, setSelectedEquipment] = useState([]);

  // =============================================================
  // LOAD MAIN CONFIG
  // =============================================================
  useEffect(() => {
    const loadConfig = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/VFreeBuildConfig`);
        setConfig(res.data);
      } catch (err) {
        console.error("Failed to load build config:", err);
      }
    };

    loadConfig();
  }, []);

  // =============================================================
  // LOAD DYNAMIC PRICES (colors + equipment)
  // =============================================================
  useEffect(() => {
    const loadPrices = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/VFreePrices`);

        // Convert colors to { "ColorName": price }
        const colorObj = {};
        res.data.colors.forEach((c) => {
          colorObj[c.name] = c.price;
        });

        // Convert equipment to { id: price }
        const equipObj = {};
        res.data.equipment.forEach((e) => {
          equipObj[e.id] = e.price;
        });

        setColorPrices(colorObj);
        setEquipmentPrices(equipObj);
      } catch (err) {
        console.error("Failed to load prices:", err);
      }
    };

    loadPrices();
  }, []);

  // =============================================================
  // DO NOT PLACE HOOKS BELOW THIS POINT
  // =============================================================

  // If nothing loaded → don't render yet
  if (!config || Object.keys(colorPrices).length === 0 || Object.keys(equipmentPrices).length === 0)
    return null;

  const BASE_PRICE = config.basePrice;
  const CURRENCY = config.currency;

  // =============================================================
  // TOTAL PRICE CALCULATION
  // =============================================================
  const calculateTotal = () => {
    let total = BASE_PRICE;

    // Exterior color pricing
    if (selectedExterior) {
      total += colorPrices[selectedExterior.name] || 0;
    }

    // Extra equipment pricing
    selectedEquipment.forEach((id) => {
      total += equipmentPrices[id] || 0;
    });

    return total;
  };

  const finalPrice = calculateTotal();

  // =============================================================
  // TOGGLE EQUIPMENT
  // =============================================================
  const toggleEquipment = (id) => {
    setSelectedEquipment((prev) =>
      prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id]
    );
  };

  // =============================================================
  // RENDER UI
  // =============================================================
  return (
    <div className="bvfnaved">
      <Navbar />

      <BuildFreeExterior onSelect={(color) => setSelectedExterior(color)} />

      <BuildFreeInterior onSelect={(interior) => setSelectedInterior(interior)} />

      <BuildFreeAdditionalEquipment
        selectedEquipment={selectedEquipment}
        toggleEquipment={toggleEquipment}
         equipmentPrices={equipmentPrices}
         currency={CURRENCY}
      />

      <BuildFreeOrder
        currency={CURRENCY}
        equipmentPrices={equipmentPrices}
        selectedExterior={selectedExterior}
        selectedInterior={selectedInterior}
        selectedEquipment={selectedEquipment}
      />

      <Footer />
    </div>
  );
};

export default BuildVoyahFree;
